export default __webpack_public_path__ + "static/media/pawann.31705072.png";